/**
 * COP Thumbnail Navigation Override
 *
 * Overrides Dawn's default thumbnail slider arrows so they navigate
 * one thumbnail at a time and select it (swapping the main image),
 * instead of scrolling by `data-step` items.
 */
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const thumbSlider = gallery.querySelector('.thumbnail-slider');
  if (!thumbSlider) return;

  const prevBtn = thumbSlider.querySelector('.slider-button--prev');
  const nextBtn = thumbSlider.querySelector('.slider-button--next');
  if (!prevBtn || !nextBtn) return;

  function getThumbItems() {
    return Array.from(thumbSlider.querySelectorAll('.thumbnail-list__item'));
  }

  function getActiveIndex(items) {
    return items.findIndex((item) => item.querySelector('[aria-current="true"]'));
  }

  function navigateTo(items, index) {
    if (index < 0 || index >= items.length) return;
    const btn = items[index].querySelector('button.thumbnail');
    if (btn) btn.click();
    items[index].scrollIntoView({ inline: 'nearest', behavior: 'smooth', block: 'nearest' });
    updateArrows(items, index);
  }

  function updateArrows(items, index) {
    prevBtn.disabled = index <= 0;
    nextBtn.disabled = index >= items.length - 1;
  }

  // Override click handlers — stop Dawn's default scroll behavior
  function handleNav(direction, event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const items = getThumbItems();
    const current = getActiveIndex(items);
    const next = direction === 'prev' ? current - 1 : current + 1;
    navigateTo(items, next);
  }

  // Use capture phase to intercept before Dawn's handler
  prevBtn.addEventListener('click', (e) => handleNav('prev', e), true);
  nextBtn.addEventListener('click', (e) => handleNav('next', e), true);

  // Set initial arrow state
  const items = getThumbItems();
  updateArrows(items, getActiveIndex(items));

  // Update arrows when thumbnail selection changes (e.g. variant change)
  const observer = new MutationObserver(() => {
    const items = getThumbItems();
    updateArrows(items, getActiveIndex(items));
  });
  observer.observe(thumbSlider, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
});
